import type { App as Application } from 'vue'
import { Permissions } from '@/types'
import { useSpace } from '@/store/modules/App/space'
import APPS from '@/constants/apps'

export default {
  install: function (app: Application): void {
    app.config.globalProperties.$hasTaskPermissions = function (): boolean {
      const spaceStore = useSpace()
      const isAdmin = spaceStore.isSpaceAdmin

      return (
        this.$isAppInstalled(APPS.tasks) &&
        (this.$can(Permissions.AccessTasks) ||
          this.$can(Permissions.CreateTasks) ||
          this.$can(Permissions.ExecuteTasks) ||
          this.$can(Permissions.EditTasks) ||
          this.$can(Permissions.DeleteTasks) ||
          isAdmin)
      )
    }
  },
}
